module.exports = __webpack_public_path__ + "img/free-icon-viber-3938039.6833a8b9.png";